import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FileUploaderFilesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 20px;
`;

export const FileUploaderFileItemPadding = styled.div`
  padding-top: 100%;
`;

export const FileUploaderFileImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  ${({ opacity }) =>
    opacity &&
    `
    opacity: ${opacity};
  `}
  ${({ blur }) =>
    blur &&
    `
    filter: blur(${blur}px);
  `}
`;

export const FileUploaderResizedFileImg = styled.img.attrs(({ dimenParamToChange, ratio }) => {
  const width = dimenParamToChange === 'width' ? `calc(100% * ${ratio})` : '100%';
  const height = dimenParamToChange === 'height' ? `calc(100% * ${ratio})` : '100%';

  return {
    style: {
      width,
      height,
    },
  };
})`
  position: absolute;
  top: 0;
`;

export const FileUploaderImgDeleteOverlay = styled.div`
  position: absolute;
  top: 0;
  display: none;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.grey500};
  opacity: 0.6;
  cursor: pointer;
`;

export const FileUploaderImgDeleteIcon = styled.span`
  display: none;
  cursor: pointer;
  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    position: absolute;
    top: 7px;
    right: 7px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const FileUploaderFileItemWrapper = styled.div`
  position: relative;

  &:hover {
    ${FileUploaderImgDeleteOverlay} {
      display: block;
    }
    ${FileUploaderImgDeleteIcon} {
      display: block;
    }
  }
`;

export const FileUploaderImgPreview = styled.img``;

export const FileUploaderBtn = styled.input`
  display: none;
`;

export const FileUploaderLabelWrapper = styled.div`
  text-align: center;
`;

export const FileUploaderLabel = styled(typography.BodyTextOneRegularTypography)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  margin: 0;
  padding: 12px 0;
  color: ${({ theme }) => theme.colors.black};
  border: 1px dashed ${({ theme }) => theme.colors.grey005};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  &:before {
    content: '\\e949';
    font-family: 'Icomoon';
    margin-inline-end: 5px;
  }
`;
